<template>
    <v-card class="statisticsDonutComponent pa-3 pt-0">
        <v-card-title>
            {{ $t("events_list") }}
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
            <DatatableV2 v-if="datatableKey > 0" :disableSaveParams="true" :key="datatableKey" :flat="true" :url="apiUrl" :forceDisableSort="true" :prefilters="filters" @exportStatisticsEvents="exportStatisticsEvents" />
        </v-card-text>

        <v-dialog width="600" class="rounded-lg" scrollable persistent v-model="openExportDialog">
            <v-card>
                <v-toolbar tile flat dark class="bg-gradient">
                    <v-btn depressed color="transparent" class="square mr-2" @click.native="closeExportDialog"><v-icon dark small>$prev</v-icon></v-btn>
                    <v-toolbar-title>{{$t('export')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn outlined dark depressed @click.native="closeExportDialog">{{ $t("cancelLabel") }}</v-btn>
                    <v-btn outlined dark depressed @click="validateExport" class="ml-3">{{ $t("actionexport") }}</v-btn>
                </v-toolbar>
                <v-card-text class="pt-3">
                    <v-form ref="exportForm">
                        <div v-for="(checkbox, index) in exportItems" :key="'check_' + index">
                            <v-checkbox v-model="checkbox.value" :label="checkbox.label" dense color="primary" hide-details></v-checkbox>
                        </div>
                    </v-form>

                    <div v-if="showProgressBar" class="mt-4">
                        <v-progress-linear :value="progressBarValue" color="success" height="20" rounded dark>
                            <template v-slot:default="{ value }">
                                <strong>{{ value }}%</strong>
                            </template>
                        </v-progress-linear>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog persistent width="400" v-model="showDownload">
            <v-card>
                <v-card-text class="pa-6">
                    <h5 class="icon-title">
                        {{ $t('downloadReady') }}
                        <v-btn @click="showDownload = false" text class="square">
                            <v-icon small>$close</v-icon>
                        </v-btn>
                    </h5>
                    <div class="text-center mt-4 mb-2">
                        <a :href="downloadUrl" @click="" download class="exportBtn">{{$t('clickForDownload')}}</a>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import GenericDataService from '@/services/GenericDataService';
import DatatableV2 from '@/components/DatatableV2';

export default {
    name: "statisticsEventsListComponent",
    props: ["filters", "instantData"],
    components: { DatatableV2 },
    data() {
        return {
            api: this.$store.state.auth.apiUrl,
            apiUrl: "/stats/getStatisticsEvents",
            datatableKey: 0,
            openExportDialog: false,
            uniqid: null,
            downloadUrl: '',
            showDownload: false,
            progressBarUrl: '/export/getExportCache?uniqid=',
            showProgressBar: false,
            progressBarInterval: null,
            progressBarValue: 0,
        }
    },
    computed: {
        exportItems() {
            if(!this.instantData.events)
                return [];
            
            let exportItems = [];
            Object.keys(this.instantData.events).forEach((event) => { 
                exportItems.push({ label: this.$t("event_list_" + event), value: false, event: event });
            });
            return exportItems;
        },
    },
    watch: {
        filters: {
            handler(newFilters) {
                this.datatableKey++;
            },
            deep: true
        }
    },
    methods: {
        exportStatisticsEvents(params) {
            this.openExportDialog = true;
            this.uniqid = params.uniqid;
        },
        validateExport() {
            let payload = {};
            payload.filters = this.filters;
            payload.types = this.exportItems.filter(item => item.value).map(item => item.event);
            payload.uniqid = this.uniqid;

            this.startProgressBar();

            GenericDataService.postData('/stats/exportStatisticsEvents', payload).then((response)=> {
                this.stopProgressBar();
                this.downloadUrl = this.api + response.data.data.directDownload
                this.showDownload = true;
            }).catch((e) =>  {
                this.stopProgressBar();
            });
        },
        startProgressBar() {
            this.showProgressBar = true;
            this.progressBarValue = 0;
            this.progressBarInterval = setInterval(() => {
                GenericDataService.getData(this.progressBarUrl + this.uniqid).then((response) => {
                    if(response.data.data)
                        this.progressBarValue = Math.round((100 * response.data.data.currentLoop) / response.data.data.nbLoop);
                });
            }, 500);
        },
        stopProgressBar() {
            this.progressBarValue = 100;
            clearInterval(this.progressBarInterval);
        },
        closeExportDialog() {
            this.openExportDialog = false;
            this.$refs.exportForm.reset();
            this.stopProgressBar();
            this.showProgressBar = false;
            this.progressBarValue = 0;
        },
    },
}
</script>